// extracted by mini-css-extract-plugin
export default {"expandButton":"expandButton_m80_","expandButtonIcon":"expandButtonIcon_BlDH"};